// extracted by mini-css-extract-plugin
export default {"shareIcon":"index_shareIcon_hgjQI"};